import { produce } from "immer";
import * as uiActions from "store/actions/uiActions";

const initialState = {
  isLoading: true,
  errorMessage: null,
  logo: null,
  developer_logo: null,
  developer_url: "",
  knowledge_base: "",
  powered_by: 1,
  qr_login: 0,
  favicon: null,
  darkLogo: null,
  background: null,
  logo_size: 60,
  title: "",
  main: false,
  domains: [],
  login_theme: null,
  pw_change_url: null,
  logout_url: "",
  light: { "primary-color": null, "sidebar-bg-color": null },
  dark: { "primary-color": null, "sidebar-bg-color": null },
  banner: null,
  darkBanner: null,
  bannerLink: null,
  mc_login_banner_link: null,
  mc_login_banner_logo: null,
  logoLink: null,
  metaDescription: null
};

const reducer = produce((draft, action) => {
  switch (action.type) {
    case uiActions.SET_THEME: {
      let {
        logo,
        darkLogo,
        favicon,
        background,
        title,
        main,
        domains,
        language,
        login_theme,
        pw_change_url,
        logout_url,
        light,
        dark,
        developer_logo,
        developer_url,
        knowledge_base,
        powered_by,
        qr_login,
        logo_size,
        banner,
        darkBanner,
        bannerLink,
        mc_login_banner_logo,
        mc_login_banner_link,
        logoLink,
        metaDescription
      } = action.payload;

      draft.isLoading = false;
      draft.logo = logo;
      draft.darkLogo = darkLogo;
      draft.background = background;
      draft.title = title;
      draft.favicon = favicon;
      draft.main = main;
      draft.domains = domains;
      draft.language = language;
      draft.login_theme = login_theme;
      draft.pw_change_url = pw_change_url;
      draft.logout_url = logout_url;
      draft.light = light;
      draft.dark = dark;
      draft.developer_logo = developer_logo;
      draft.developer_url = developer_url;
      draft.knowledge_base = knowledge_base;
      draft.powered_by = powered_by;
      draft.logo_size = logo_size;
      draft.qr_login = qr_login;
      draft.banner = banner;
      draft.darkBanner = darkBanner;
      draft.bannerLink = bannerLink;
      draft.mc_login_banner_link = mc_login_banner_link;
      draft.mc_login_banner_logo = mc_login_banner_logo;
      draft.logoLink = logoLink;
      draft.metaDescription = metaDescription;
      break;
    }

    case uiActions.SET_THEME_ERROR_MESSAGE: {
      draft.errorMessage = action.payload;
      draft.isLoading = false;
      break;
    }

    case uiActions.RESET_THEME_ERRORS: {
      draft.errorMessage = null;
      break;
    }

    default:
      return draft;
  }
}, initialState);

export default reducer;
